"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Jun 28 2018
 */

var immutable_1 = require("immutable");

var CodebookItem_1 = require("../../core/model/codebook/CodebookItem");
/**
 * Represents site format, such as hypermarket or supermarket, but the
 * class supports any format, it only needs to be identified by title.
 *
 * @author JMr
 * @author Radek Beran
 */


var SiteFormat =
/*#__PURE__*/
function (_CodebookItem_1$Codeb) {
  _inherits(SiteFormat, _CodebookItem_1$Codeb);

  /**
   * @param id
   * @param title the title of the format
   * @param externalId the external id
   */
  function SiteFormat(id, title, externalId) {
    var _this;

    _classCallCheck(this, SiteFormat);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteFormat).call(this, id, title, null, immutable_1.List(), externalId));
    _this.id = id;
    _this.title = title;
    _this.externalId = externalId;
    return _this;
  }

  return SiteFormat;
}(CodebookItem_1.CodebookItem);

exports.SiteFormat = SiteFormat;
/** Name of code book for generic code book API. */

SiteFormat.CODEBOOK_NAME = 'sites.formats';